import { faBoxesStacked } from '@awesome.me/kit-24322b77ac/icons/classic/regular';
import { faChargingStation, faFire, faHammer, faShield, faSwords, faUsers } from '@awesome.me/kit-24322b77ac/icons/classic/solid';
import { faDroplet, faHatCowboySide } from '@awesome.me/kit-24322b77ac/icons/sharp-duotone/regular';
import { registerIcons } from '@game/ui';

// Initialize icon registry for [prefix, name] lookups
export function initializeIconRegistry(): void {
  registerIcons([
    { icon: faDroplet, prefix: 'fasdr', name: 'droplet' },
    { icon: faHatCowboySide, prefix: 'fasdr', name: 'hat-cowboy-side' },
    { icon: faSwords, prefix: 'fas', name: 'swords' },
    { icon: faShield, prefix: 'fas', name: 'shield' },
    { icon: faFire, prefix: 'fas', name: 'fire' },
    { icon: faChargingStation, prefix: 'fas', name: 'charging-station' },
    { icon: faHammer, prefix: 'fas', name: 'hammer' },
    { icon: faBoxesStacked, prefix: 'fas', name: 'boxes-stacked' },
    { icon: faUsers, prefix: 'fas', name: 'users' },
  ]);
}
